module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/18mill-inactive-4780a5b0f28298c8babd8b5f0694228f.png";